import numeral from 'numeral'

numeral.register('locale', 'ja-JA', {
	delimiters: {
		thousands: ',',
		decimal: '.',
	},
	abbreviations: {
		thousand: 'K',
		million: 'MM',
		billion: 'BN',
		trillion: 'TN',
	},
	currency: {
		symbol: '$',
	},
})

numeral.locale('ja_JA')
